import React from "react";
import styles from "./DefaultReport.module.scss";
import qrcode from "../../../../images/qr.png";
import regBarcode from "../../../../images/registartinbarcode.png";
import signature from "../../../../images/Picture5.jpg";
import { MdOutlineEmail } from "react-icons/md";
import { AiOutlineGlobal } from "react-icons/ai";
import Image from "react-bootstrap/Image";

const DefaultReport = ({
  clinic,
  address,
  qrCode,
  item,
  referrer,
  selectedItem,
  watermark,
  isoLogo,
  forPrint = false,
}) => {
  const safeImageProps = {
    crossOrigin: forPrint ? "anonymous" : undefined,
  };

  /** ------------------ HEADER LEFT ------------------ **/
  const invoiceHeaderLeft = () => (
    <div className={styles.page}>
      <div className={styles["header"]}>
        <div className={styles["logo"]} style={{ width: "72%" }}>
          {clinic?.hospitalInfo?.pdfHeader && (
            <Image
              src={clinic.hospitalInfo.pdfHeader}
              alt="logo"
              {...safeImageProps}
            />
          )}

          <div>
            <p className={styles["bold"]}>{clinic?.clinicName}</p>
            <p>{address}</p>
          </div>

          <div className={styles["info-links"]}>
            <p>
              <AiOutlineGlobal />{" "}
              <span>{clinic?.hospitalInfo?.web_address}</span>
            </p>
            <p>
              <MdOutlineEmail /> <span>{clinic?.clinicEmail}</span>
            </p>
            <p>CIN: U74140DL2015PTC279229</p>
          </div>

          <p>{clinic?.hospitalInfo?.iso_certificate}</p>
        </div>

        <div className={styles["rightside"]}>
          <div>
            <Image
              src={isoLogo || clinic?.hospitalInfo?.ISOLogo}
              alt="iso"
              {...safeImageProps}
            />
          </div>
        </div>
      </div>
    </div>
  );

  /** ------------------ HEADER CENTER ------------------ **/
  const invoiceHeaderCenter = () => (
    <div className={styles["headerCenter"]}>
      <div className={styles["header"]} style={{ alignItems: "center" }}>
        <div className={styles["logo"]} style={{ width: "30%" }}>
          <div>
            <p className={styles["bold"]} style={{ fontSize: "1rem" }}>
              {clinic?.clinicName}
            </p>
            <p>{address}</p>
          </div>

          <div className={styles["info-links"]}>
            <p>
              <AiOutlineGlobal />{" "}
              <span>{clinic?.hospitalInfo?.web_address}</span>
            </p>
          </div>

          <div className={styles["info-links"]}>
            <p>
              <MdOutlineEmail /> <span>{clinic?.clinicEmail}</span>
            </p>
          </div>

          <p>CIN: U74140DL2015PTC279229</p>

          <p>{clinic?.hospitalInfo?.iso_certificate}</p>
        </div>

        {clinic?.hospitalInfo?.pdfHeader && (
          <Image
            src={clinic.hospitalInfo.pdfHeader}
            alt="logo"
            style={{ width: "22rem", height: "4.5rem" }}
            {...safeImageProps}
          />
        )}

        <div className={styles["rightside"]}>
          {clinic?.hospitalInfo?.displayISOlogo && (
            <Image
              src={isoLogo || clinic?.hospitalInfo?.ISOLogo}
              alt="iso"
              {...safeImageProps}
            />
          )}
        </div>
      </div>
    </div>
  );

  /** ------------------ HEADER RIGHT ------------------ **/
  const invoiceHeaderRight = () => (
    <div className={styles["header"]}>
      <div className={styles["rightside"]}>
        <Image
          src={isoLogo || clinic?.hospitalInfo?.ISOLogo}
          alt="iso"
          {...safeImageProps}
        />
      </div>

      <div className={styles["logo"]} style={{ width: "72%" }}>
        {clinic?.hospitalInfo?.pdfHeader && (
          <Image
            src={clinic.hospitalInfo.pdfHeader}
            alt="logo"
            {...safeImageProps}
          />
        )}

        <div>
          <p className={styles["bold"]}>{clinic?.clinicName}</p>
          <p>{address}</p>
        </div>

        <div className={styles["info-links"]}>
          <p>
            <AiOutlineGlobal /> <span>{clinic?.hospitalInfo?.web_address}</span>
          </p>
          <p>
            <MdOutlineEmail /> <span>{clinic?.clinicEmail}</span>
          </p>
          <p>CIN: U74140DL2015PTC279229</p>
        </div>

        <p>{clinic?.hospitalInfo?.iso_certificate}</p>
      </div>
    </div>
  );

  /** ------------------ MAIN UI ------------------ **/
  return (
    <>
      <div className={styles["page"]}>
        {clinic?.hospitalInfo?.headerAlignment === "left" &&
          invoiceHeaderLeft()}

        {clinic?.hospitalInfo?.headerAlignment === "right" &&
          invoiceHeaderRight()}

        {clinic?.hospitalInfo?.headerAlignment === "center" &&
          invoiceHeaderCenter()}

        {/* Watermark */}
        <div className={styles["waterMark"]}>
          <img
            src={watermark || clinic?.hospitalInfo?.waterMark}
            alt="watermark"
            {...safeImageProps}
          />
        </div>

        {/* Patient Section */}
        {/* Patient Information Section - Professional Grid Layout */}
        <div className={styles["middleSection"]}>
          <div
            style={{
              padding: "10px 10px",
              fontSize: "14px",
              lineHeight: "1.8",
              color: "#000",
              backgroundColor: "#fff",
            }}
          >
            <div className="row">
              {/* Left Column: Patient Details */}
              <div className="col-6">
                <div className="d-flex mb-1">
                  <span style={{ width: "90px", fontWeight: "bold" }}>
                    Name
                  </span>
                  <span>
                    :{" "}
                    {selectedItem?.patientName ||
                      item?.appointmentDetails?.patientName ||
                      "N/A"}
                  </span>
                </div>
                <div className="d-flex mb-1">
                  <span style={{ width: "90px", fontWeight: "bold" }}>
                    Patient ID
                  </span>
                  <span>
                    :{" "}
                    {selectedItem?.patientId?.UHID ||
                      item?.appointmentDetails?.patientId?.UHID ||
                      "N/A"}
                  </span>
                </div>
                <div className="d-flex">
                  <span style={{ width: "90px", fontWeight: "bold" }}>
                    Invoice ID
                  </span>
                  <span>: {item?.invoiceId || "N/A"} </span>
                </div>
              </div>

              {/* Right Column: Invoice Timing Details */}
              <div className="col-6">
                <div className="d-flex mb-1">
                  <span style={{ width: "110px", fontWeight: "bold" }}>
                    Invoice Date
                  </span>
                  <span>
                    :{" "}
                    {item?.date
                      ? new Date(item.date).toLocaleDateString("en-GB")
                      : "N/A"}{" "}
                  </span>
                </div>
                <div className="d-flex">
                  <span style={{ width: "110px", fontWeight: "bold" }}>
                    Payment Date
                  </span>
                  <span>
                    :{" "}
                    {item?.receiptId?.paymentDetails?.[0]?.paymentDate
                      ? new Date(
                          item.receiptId.paymentDetails[0].paymentDate,
                        ).toLocaleDateString("en-GB")
                      : "N/A"}{" "}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Table */}
        <div className={styles["tableDiv"]}>
          {(() => {
            const data =
              selectedItem && Object.keys(selectedItem).length
                ? selectedItem
                : item || {};

            let rows = [];
            let slNo = 1;
            let computedTotal = 0;

            const addRow = (name, rate, tax = 0) => {
              const r = Number(rate || 0);
              const t = Number(tax || 0);
              const sgst = t / 2;
              const cgst = t / 2;
              const total = r + (r * t) / 100;

              computedTotal += total;

              rows.push(
                <tr key={`row-${slNo}`}>
                  <td className="center">{slNo++}</td>
                  <td className="left">{name}</td>
                  <td className="right">Rs {r.toFixed(2)}</td>
                  <td className="center">{t.toFixed(2)}%</td>
                  <td className="center">{sgst.toFixed(2)}%</td>
                  <td className="center">{cgst.toFixed(2)}%</td>
                  <td className="right">Rs {total.toFixed(2)}</td>
                </tr>,
              );
            };

            const getTax = (obj) => {
              if (!obj) return 0;
              if (typeof obj?.tax === "number") return obj.tax;
              return 0;
            };

            /* ================= PATHOLOGY ================= */

            (data?.tests || []).forEach((it) =>
              addRow(
                it?.testId?.testName || "Test",
                it?.price || it?.totalAmount,
                getTax(it?.testId) || getTax(it),
              ),
            );

            (data?.profiles || []).forEach((it) =>
              addRow(
                it?.profileId?.profileName || "Profile",
                it?.price || it?.totalAmount,
                getTax(it?.profileId) || getTax(it),
              ),
            );

            /* ================= DENTAL / HAIR / SKIN / GENERAL ================= */

            (data?.dentalServices || []).forEach((it) =>
              addRow(
                it?.serviceName || "Dental Service",
                it?.price,
                getTax(it),
              ),
            );

            (data?.hairServices || []).forEach((it) =>
              addRow(it?.serviceName || "Hair Service", it?.price, getTax(it)),
            );

            (data?.skinServices || []).forEach((it) =>
              addRow(it?.serviceName || "Skin Service", it?.price, getTax(it)),
            );

            (data?.generalServices || []).forEach((it) =>
              addRow(
                it?.serviceName || "General Service",
                it?.price,
                getTax(it),
              ),
            );

            /* ================= PHYSIOTHERAPY ================= */

            (data?.physiotherapyService || []).forEach((it) =>
              addRow(
                it?.physioId?.serviceDetailName || "Physiotherapy",
                it?.price,
                getTax(it?.physioId),
              ),
            );

            /* ================= RADIOLOGY ================= */

            (data?.radioServices || []).forEach((it) => {
              const serviceName =
                it?.radiologyServiceInfo?.serviceName || "Radiology";
              (it?.radiologyServiceInfo?.serviceDetails || []).forEach(
                (detail) => {
                  addRow(
                    `${serviceName} - ${
                      detail?.radioId?.serviceDetailsName || detail?.serviceName
                    }`,
                    detail?.price,
                    getTax(detail?.radioId),
                  );
                },
              );
            });

            /* ================= HEALTH SCREENING ================= */

            (data?.healthScreeningDetails || []).forEach((it) =>
              addRow(
                it?.healthScreeningName || "Health Screening",
                it?.healthScreeningAmount,
                getTax(it),
              ),
            );

            (data?.healthPackageDetails || []).forEach((it) =>
              addRow(
                it?.healthPackageName || "Health Package",
                it?.healthPackageAmount,
                getTax(it),
              ),
            );

            /* ================= CONSULTATION ================= */

            (data?.consultationService || []).forEach((it) =>
              addRow(
                it?.doctorName ||
                  it?.doctorId?.name ||
                  it?.serviceName ||
                  "Consultation",
                it?.price || it?.consultationFee || 0, // Added price fallback
                getTax(it),
              ),
            );

            // Case 2: consultationDetails array (This matches your provided JSON structure)
            (data?.consultationDetails || []).forEach((it) =>
              addRow(
                // Your JSON has doctor name inside it?.consultationId?.timeSlot or similar
                // Using a generic "Consultation" or doctor name if available
                it?.doctorId?.name ||
                  it?.consultationId?.doctorName ||
                  "Consultation",
                it?.price || it?.consultationFee || 0, // In your JSON, this is "price": 500
                getTax(it),
              ),
            );

            // Case 3: single consultation object
            if (
              data?.consultationService &&
              !Array.isArray(data.consultationService)
            ) {
              addRow(
                data?.consultationService?.doctorName || "Consultation",
                data?.consultationService?.price ||
                  data?.consultationService?.consultationFee ||
                  0,
                getTax(data?.consultationService),
              );
            }

            /* ================= IF NO SERVICES ================= */

            if (rows.length === 0) {
              return (
                <table>
                  <thead>
                    <tr>
                      <th>Test Name</th>
                      <th>Result</th>
                      <th>Unit</th>
                      <th>Bio Ref Interval</th>
                      <th>Method</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{data?.serviceName || "N/A"}</td>
                      <td>{data?.result || "-"}</td>
                      <td>{data?.unit || "-"}</td>
                      <td>{data?.bioRef || "-"}</td>
                      <td>{data?.method || "-"}</td>
                    </tr>
                  </tbody>
                </table>
              );
            }

            /* ================= PAYMENT SUMMARY ================= */

            // 1. Sum all paid amounts from the paymentDetails array
            const paidAmount = (item?.receiptId?.paymentDetails || []).reduce(
              (acc, curr) => acc + (Number(curr.paidAmount) || 0),
              0,
            );

            // 2. Get the discount
            const discount = Number(item?.receiptId?.discountPrice) || 0;

            // 3. Calculate Balance (computedTotal is your calculated row sum)
            const balanceDue = computedTotal - paidAmount - discount;

            return (
              <>
                <table>
                  <thead>
                    <tr>
                      <th>SL NO</th>
                      <th>ITEM NAME</th>
                      <th>RATE</th>
                      <th>TAX</th>
                      <th>SGST</th>
                      <th>CGST</th>
                      <th>AMOUNT</th>
                    </tr>
                  </thead>
                  <tbody>{rows}</tbody>
                </table>

                <div className={styles.paymentSummaryWrapper}>
                  <div className={styles.summaryBox}>
                    <div className={styles.summaryRow}>
                      <span>Amount</span>
                      <strong>{computedTotal.toFixed(0)}</strong>
                    </div>
                    <div className={styles.summaryRow}>
                      <span>Discount</span>
                      <strong>{discount.toFixed(0)}</strong>
                    </div>
                    <div className={styles.summaryRow}>
                      <span>Paid Amount</span>
                      <strong>{paidAmount.toFixed(0)}</strong>
                    </div>
                    <div
                      className={`${styles.summaryRow} ${styles.balanceRow}`}
                    >
                      <span>Balance Due</span>
                      <strong
                        style={{ color: balanceDue > 0 ? "red" : "#40be47" }}
                      >
                        {balanceDue <= 0 ? "0" : balanceDue.toFixed(0)}
                      </strong>
                    </div>
                  </div>
                </div>
              </>
            );
          })()}
        </div>

        {/* Footer */}
        <div className={styles["footerSection"]}>
          <div className={styles["footerSignatureBar"]}>
            <div className={styles["billedBy"]}>
              <strong>Billed By :</strong> {clinic?.clinicName || "SimpleeKare"}
            </div>
            <div className={styles["signatureText"]}>
              {clinic?.hospitalInfo?.signature && (
                <Image
                  src={clinic.hospitalInfo.signature}
                  style={{
                    width: "120px",
                    display: "block",
                    marginBottom: "5px",
                  }}
                  {...safeImageProps}
                />
              )}
              <strong>Authorized Signature</strong>
            </div>
          </div>

          <div className={styles["footerBottom"]}>
            <div className={styles["footerqrcode"]}>
              <Image src={qrCode || qrcode} alt="qrcode" {...safeImageProps} />
            </div>
            <p className={styles["disclaimer"]}>
              * No Extra Amount to be paid apart from Billing Amount.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default DefaultReport;
